import { Controller } from "@hotwired/stimulus"
import { coerce } from "../lib/helpers"

const AUTOPLAY_KEY = "toolbox::autoplay-video"

export default class extends Controller {
  static targets = ["player", "autoplay"]

  initialize() {
    window.currentYoutubePlayer = null

    const tag = document.createElement('script')
    tag.src = "https://www.youtube.com/iframe_api"
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    this.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this)
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady

    this.lsAutoplaySetting = this.lsAutoplaySetting || false
  }

  connect() {
    this.setupVideo()
    this.setAutoplayToggle()
  }

  onYouTubeIframeAPIReady() {
    this.setupVideo()
    this.setAutoplayToggle()
  }

  setupVideo() {
    if (window.currentYoutubePlayer != null) {
      window.currentYoutubePlayer.destroy()
    }

    if (typeof (YT) === "undefined") {
      return
    }

    new YT.Player(this.playerTarget, {
      videoId: this.videoId,
      playerVars: {
        'playsinline': 1,
        'autoplay': this.autoplaySetting,
        // Captions on by default wherever the video has them (WCAG 1.2.2).
        // Only a request: YouTube ignores it for a video with no caption track,
        // and a viewer who turns them off keeps that preference.
        'cc_load_policy': 1,
      },
      events: {
        'onReady': this.onPlayerReady.bind(this)
      }
    })
  }

  get videoId() {
    return this.data.get("id")
  }

  get autoplaySetting() {
    if (this.lsAutoplaySetting) {
      return 1
    } else {
      return 0
    }
  }

  get lsAutoplaySetting() {
    return coerce(
      localStorage.getItem(AUTOPLAY_KEY)
    )
  }

  set lsAutoplaySetting(value) {
    localStorage.setItem(AUTOPLAY_KEY, value.toString())
  }

  toggle() {
    this.lsAutoplaySetting = !this.lsAutoplaySetting
  }

  setAutoplayToggle() {
    if (this.hasAutoplayTarget) {
      this.autoplayTarget.checked = this.lsAutoplaySetting
    }
  }

  onPlayerReady(event) {
    window.currentYoutubePlayer = event.target

    // The API builds the iframe itself, so this is the only place to name it.
    // Without a title a screen reader announces the frame as "frame" and the
    // user has no way to know what entering it gets them (WCAG 4.1.2).
    const title = this.data.get("title")
    if (title) { event.target.getIframe().title = title }
  }
}